module.exports = __webpack_public_path__ + "img/cp4_02.fe89a663.jpg";